/* UNA AI imagery landing: gallery filter + quote form (Zapier, UTM/GCLID attribution). */
document.querySelectorAll('[data-uai]').forEach(function(root){

  // Gallery filter
  var chips = root.querySelectorAll('.uai-chip');
  var shots = root.querySelectorAll('.uai-shot');
  chips.forEach(function(c){
    c.addEventListener('click', function(){
      var f = c.getAttribute('data-filter');
      chips.forEach(function(x){ var on = x === c; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      shots.forEach(function(sh){ sh.hidden = !(f === 'all' || sh.getAttribute('data-cat') === f); });
    });
  });

  var form = root.querySelector('form');
  if (!form) return;

  // Package buttons pre-fill the hidden package field
  root.querySelectorAll('[data-package]').forEach(function(a){
    a.addEventListener('click', function(){ form.elements['package'].value = a.getAttribute('data-package'); });
  });

  var HOOK = root.getAttribute('data-hook');
  var THANKS = root.getAttribute('data-thanks') || '/';
  var SEGMENT = root.getAttribute('data-segment') || '';
  var VALUE = parseFloat(root.getAttribute('data-value')) || 0;
  var keys = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid'];
  var qs = new URLSearchParams(window.location.search);
  var store = {};
  try { store = JSON.parse(sessionStorage.getItem('una_attrib') || '{}'); } catch(e) {}
  keys.forEach(function(k){ if (qs.get(k)) store[k] = qs.get(k); });
  try { sessionStorage.setItem('una_attrib', JSON.stringify(store)); } catch(e) {}
  keys.forEach(function(k){ if (form.elements[k]) form.elements[k].value = store[k] || ''; });
  form.elements['landing_page'].value = window.location.href.split('#')[0].split('?')[0];

  form.addEventListener('submit', function(ev){
    ev.preventDefault();
    var err = form.querySelector('.uai-err');
    if (!form.checkValidity()) { err.style.display = 'block'; if (form.reportValidity) form.reportValidity(); return; }
    err.style.display = 'none';
    if (form.elements['company_url_hp'].value) { window.location.href = THANKS; return; }
    if (!HOOK) { err.textContent = 'This form is not connected yet.'; err.style.display = 'block'; return; }
    var btn = form.querySelector('button[type=submit]');
    btn.disabled = true; btn.textContent = 'Sending…';
    var data = new URLSearchParams(new FormData(form));
    data.delete('company_url_hp');
    if (!data.get('marketing_opt_in')) data.set('marketing_opt_in', 'no');
    data.set('submitted_at', new Date().toISOString());
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({event: 'generate_lead', lead_segment: SEGMENT, value: VALUE, currency: 'GBP'}); } catch(e) {}
    var done = false;
    var go = function(){ if (!done) { done = true; window.location.href = THANKS; } };
    fetch(HOOK, {method: 'POST', mode: 'no-cors', body: data}).then(go, go);
    setTimeout(go, 4000);
  });
});